"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureReportGroup = void 0;
/**
 * The MeasureReport resource contains the results of the calculation of a measure; and optionally a reference to the resources involved in that calculation.
 */
var MeasureReportGroup = /** @class */ (function () {
    function MeasureReportGroup() {
    }
    return MeasureReportGroup;
}());
exports.MeasureReportGroup = MeasureReportGroup;
